import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {auth} from './firebase'
import store from './store'
import { Taginput } from "buefy";
import './styles.scss'

import fontawesome from '@fortawesome/fontawesome'
// noinspection JSUnresolvedFunction
fontawesome.library.add(
    require("@fortawesome/fontawesome-free-solid/faBars"),
    require("@fortawesome/fontawesome-free-solid/faUpload"),
    require("@fortawesome/fontawesome-free-solid/faSync"),
    require("@fortawesome/fontawesome-free-solid/faCheck"),
    require("@fortawesome/fontawesome-free-solid/faHandPointer"),
    require("@fortawesome/fontawesome-free-solid/faStar"),
    require("@fortawesome/fontawesome-free-regular/faStar"),
    require("@fortawesome/fontawesome-free-solid/faChevronCircleDown"),
    require("@fortawesome/fontawesome-free-solid/faSearch"),
    require("@fortawesome/fontawesome-free-solid/faTh"),
    require("@fortawesome/fontawesome-free-solid/faThList"),
);
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon);

window.store = store;

Vue.use(Taginput);

Vue.config.productionTip = false;

let loaded = false;
auth.onAuthStateChanged(() => {
    if (!loaded) {
        loaded = true;
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
    }
});

